import React, { useEffect, useState } from "react"
import { Button } from "@cd2/components"
import { icons } from "../../constants/icons"
import { ButtonsWrapper } from "../../Components/ButtonsWrapper"

interface ISaveButtonsProps {
  isSubmitting?: boolean

  onClick(opts: { preview: boolean }): void
}

export function SaveButtons({ onClick, isSubmitting: isFormSubmitting }: ISaveButtonsProps) {
  const [isSubmitting, setIsSubmitting] = useState(false)

  useEffect(() => {
    let timeOut: any
    if (isSubmitting) {
      timeOut = setTimeout(() => setIsSubmitting(false), 2000)
    }
    return () => clearTimeout(timeOut)
  }, [isSubmitting])

  const saveButton = (opts: { preview: boolean }) => (
    <Button
      leftIcon={opts.preview ? icons.saveAndPreview : icons.save}
      disabled={isFormSubmitting}
      onClick={() => {
        if (!isSubmitting) {
          onClick(opts)
        }
      }}
    >
      Save{opts.preview ? " and Preview" : ""}
    </Button>
  )

  return (
    <ButtonsWrapper>
      {saveButton({ preview: true })}
      {saveButton({ preview: false })}
    </ButtonsWrapper>
  )
}
